import {getObjectEntries} from './object';

function getUrlSearchParamsString(params) {
    return (
        getObjectEntries(params)
            .map(([key, value]) => (
                `${key}=${value}`
            ))
            .join('&')
    );
}

export {
    getUrlSearchParamsString
};
